import React from "react";
import {useNavigate} from "react-router-dom";

export default function OrganisationCard({title, subtitle, isEnable}){
    const navigate = useNavigate();
    return (
        <div className="mb-4 order-0">
            <div className="card">
                <div className="d-flex align-items-end row">
                    <div className="col-sm-12">
                        <div className="card-body">
                            <h5 className="card-title text-netikash">{title}</h5>
                            <p className="mb-1">{subtitle}</p>
                            <div className={"row"}>
                                <div className="col-lg-6 mt-2 order-0">
                                    <button className={isEnable ? "btn btn-netikash":"btn btn-netikash disabled"} onClick={()=>{
                                        navigate("/create-organisation")
                                    }}>Créer une Organisation</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}